import React, { PureComponent } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { EnvelopeFill } from 'react-bootstrap-icons';
import './Style.scss';
import { withRouter } from 'react-router-dom'


class Footer extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            dialogVisibility: false,
        }
    }


    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    scrollToSection(id) {
        if (window.location.pathname !== '/patient') {
            this.props.history.push({
                pathname: '/patient',
                state: {}
            });
        }
        var elmnt = document.getElementById(id);
        if (elmnt) {
            elmnt.scrollIntoView({
                behavior: "smooth"
            });
        }
    }

    setStateMedthod = (key, value) => {
        this.setState({ [key]: value })
    }

    onPressEnter = (e) => {
        if (e.key === 'Enter' && this.validateEmail(this.state.email)) { 
            this.sendSubscription();
        }
    }

    sendSubscription = () => {
        if (!this.validateEmail(this.state.email)) {
            this.setStateMedthod('dialogVisibility', !this.state.dialogVisibility);
            return;
        }
    }

    mainTO() {
        window.location.href = "mailto:info@zivov.com";
    }

    setDialogVisibility = () => {
        this.setState({ dialogVisibility: !this.state.dialogVisibility })
    }

    render() {
        return (
            <span className="footerCotnainer">
                <div className="footerTop">
                    <Row>
                        <Col xs lg="4" md={4}>
                            <img
                                alt={"Zivov Logo"}
                                src={require('@Images/logo.png')}
                                className="logo" />
                            <span className="logoText">Zivov</span>
                            <h3 className="footerSummery">India's most comprehensive chronic care platform powered by AI</h3>
                            <div className="infoContainer">
                                <div className="iconContainer">
                                    <EnvelopeFill />
                                </div>
                                <div className="emailText" onClick={this.mainTO}>info@zivov.com</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <p className="footerButtonHeading">Quick Links</p>
                            <p onClick={() => { this.scrollToSection('patinetSection') }} className="footerLink linkFirst"> For Patients</p>
                            <p onClick={() => { this.scrollToSection('doctorSection') }} className=" footerLink">For Doctors</p>
                            <p className="footerLink"><a target="_blank" href={process.env.REACT_APP_COMMUNITY} >Community</a></p>
                        </Col>
                        <Col md={4}>
                            <p className="footerButtonHeading"> Subscribe to our News Letter</p>
                            <input type="text" className="referinputfield" placeholder="Email Address" 
                            onKeyDown={(e) => { this.onPressEnter(e) }} 
                            onChange={(e) => { this.setStateMedthod('email', e.target.value) }} />
                            <Button className="submitButton" onClick={() => { this.sendSubscription() }}>Submit</Button>
                        </Col>
                    </Row>

                </div>
                <div className="footerContainer">
                    <p className="f1">Copyright@2020 Zivov Technologies Pvt. Ltd. All rights reserved.</p>
                </div>
                <Modal show={this.state.dialogVisibility} onHide={this.setDialogVisibility}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Please Enter Valid Email Address.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" className="submitButton_model" onClick={this.setDialogVisibility}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
};



export default withRouter(Footer);
